import { t } from "i18next";
import { Table } from "@sentara-health/optimahealth_web";
import SearchListItem from "./SearchListItem";
import { OrderIDList, SelectedDepType } from "utils/models/CommonTypes";

// NB: Need to make these exportable in ui library
type TableCell = {
  text: any;
  colspan?: number;
  rowspan?: number;
  tableStyle?: React.CSSProperties;
};

type TableRow = TableCell[];

type Props = {
  pageList?: OrderIDList;
  page: number;
  selectedDep?: SelectedDepType;
  setSelectedDep: (v: SelectedDepType) => void;
  getIdentificationCard: Function;
};

const SearchTableDeskTop = ({
  pageList,
  selectedDep,
  page,
  setSelectedDep,
  getIdentificationCard,
}: Props) => {
  const tableHeader: TableRow = [
    { text: t("requestMemberIDCard.selectColumnHeader") },
    { text: t("requestMemberIDCard.memberID") },
    { text: t("requestMemberIDCard.name") },
    { text: t("requestMemberIDCard.relationship") },
    { text: "" },
  ];

  const noResultsRow: TableRow = [
    { text: t("noResult"), colspan: 5, tableStyle: { textAlign: "center" } },
  ];

  return (
    <div className="table-responsive">
      <Table
        header={tableHeader}
        rowsChildren={
          pageList ? (
            <SearchListItem
              {...{
                pageList,
                selectedDep,
                page,
                setSelectedDep,
                getIdentificationCard,
              }}
            />
          ) : (
            <tr>
              {noResultsRow.map((cell, index) => (
                <td key={index} colSpan={cell.colspan} style={cell.tableStyle}>
                  {cell.text}
                </td>
              ))}
            </tr>
          )
        }
        className="table table-custom-style align-middle"
        data-testid="tblRequestMemberIdCardSearchResults"
        noDataFound={t("noResult")}
      />
    </div>
  );
};

export default SearchTableDeskTop;
